import type { PropsWithChildren } from 'react'
import { Children } from 'react'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import SharedAccessTag from 'components/Pages/MyEscapesPage/PurchaseSummary/Common/SharedAccessTag'

const Header = styled(Group)`
  justify-content: space-between;
  align-items: start;

  ${mediaQueryUp.desktop} {
    grid-column: span 3;
  }
`

interface Props extends PropsWithChildren {
  order?: App.Order
}

export default function LesaPurchaseSummaryHeader(props: Props) {
  const { children, order } = props
  const childArray = Children.toArray(children)
  const categoryLabel = childArray[0]
  const statusLabels = childArray.slice(1)

  return (
    <Header direction="horizontal" horizontalAlign="space-between" verticalAlign="start">
      {categoryLabel}
      <Group direction="horizontal" gap={8} verticalAlign="center">
        {order && <SharedAccessTag order={order} hideSharedBy />}
        {statusLabels}
      </Group>
    </Header>
  )
}
